module.exports = __webpack_public_path__ + "static/grafika-new2-25e3af328d771b526ba9ac2ee65f16bc.png";